import { EmployeeInfo } from '../../types/site.types';

/**
 * Checks to see if employee is authenticated and siteViewPreference is 'Internal'
 */
export function showAsEmployee(employee: EmployeeInfo): boolean {
	return employee.isAuthenticated && employee.siteViewPreference === 'Internal';
}
